import React from 'react';
import skillsData from '../../data/skills.json';
import './skills.scss';

const Skills: React.FC = () => {
  // Helper to map skill names to Devicon classes
  const getIconClass = (skill: string) => {
    const iconMap: { [key: string]: string } = {
      "Python": "devicon-python-plain colored",
      "Java": "devicon-java-plain colored",
      "JavaScript": "devicon-javascript-plain colored",
      "TypeScript": "devicon-typescript-plain colored",
      "SQL": "devicon-postgresql-plain colored",
      "C": "devicon-c-plain colored",
      "Bash": "devicon-bash-plain colored",
      "Node.js": "devicon-nodejs-plain colored",
      "Express.js": "devicon-express-original",
      "Spring Boot": "devicon-spring-plain colored",
      "Flask": "devicon-flask-original",
      "React": "devicon-react-original colored",
      "Azure": "devicon-azure-plain colored",
      "Docker": "devicon-docker-plain colored",
      "Kubernetes": "devicon-kubernetes-plain colored",
      "GitHub Actions": "devicon-githubactions-plain colored",
      "PostgreSQL": "devicon-postgresql-plain colored",
      "Supabase": "devicon-supabase-plain colored",
      "MongoDB": "devicon-mongodb-plain colored",
      "Git": "devicon-git-plain colored",
      "Playwright": "devicon-playwright-plain colored",
      "AWS": "devicon-amazonwebservices-plain-wordmark colored",
      "GCP": "devicon-googlecloud-plain colored",
      "Linux": "devicon-linux-plain colored",
      "MySQL": "devicon-mysql-plain colored",
      "Redis": "devicon-redis-plain colored",
      "C#": "devicon-csharp-plain colored",
      "ASP.NET": "devicon-dotnetcore-plain colored"
    };
    return iconMap[skill] || "devicon-code-plain"; // Fallback icon
  };

  return (
    <section className="skills-container" id="skills">
      <h2 className="section-title">Skills</h2>
      
      <div className="skills-grid">
        {skillsData.skillsCategories.map((category, index) => (
          <div key={index} className="skill-card">
            <h3 className="category-title">{category.title}</h3>
            <div className="skill-items">
              {category.items.map((skill, idx) => (
                <div key={idx} className="skill-badge">
                  <i className={`${getIconClass(skill)} skill-icon`}></i>
                  <span className="skill-name">{skill}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
